// extracted by mini-css-extract-plugin
module.exports = {"arrow":"style_arrow__1qb5D"};